import { Sun, MoonStars } from "@phosphor-icons/react";
import { useTheme } from "@/context/ThemeContext";

export default function ThemePicker() {
  const { theme, toggle } = useTheme();
  const dark = theme === "dark";
  return (
    <button
      data-testid="theme-toggle-btn"
      onClick={toggle}
      title={dark ? "Switch to light mode" : "Switch to dark mode"}
      className="w-9 h-9 rounded-full bg-surface border border-border flex items-center justify-center hover:bg-secondary transition-colors"
    >
      {dark ? (
        <Sun size={17} weight="fill" color="#EDB05E" />
      ) : (
        <MoonStars size={17} weight="fill" color="var(--brand)" />
      )}
    </button>
  );
}
